import dayjs from "dayjs"
import { IReading } from "../meterReading/meterReading.types"
import { getLatestRegisterReading } from "@/helpers/meterRegisterHelper"
import {
  IRegister,
  IRegisterReadingFilters,
  RateNames,
} from "./meterRegister.types"
import { DAYS_YEAR } from "@/constants/general"

const DEFAULT_UPPER_BOUND = 9999999

export class Register implements IRegister {
  constructor(
    public id: number,
    public identifier: string,
    public rateName: RateNames,
    public usage: number,
    public readings: IReading[],
  ) {}

  getLatestReading(filters: IRegisterReadingFilters): IReading | undefined {
    return getLatestRegisterReading(this, filters)
  }

  isReadingWithinBounds(cumulative: number): boolean {
    return cumulative >= this.lowerBound && cumulative <= this.upperBound
  }

  get lastRealRead(): IReading | undefined {
    return getLatestRegisterReading(this)
  }

  get lastRead(): IReading | undefined {
    return getLatestRegisterReading(this, {
      areSystemReadsIncluded: true,
    })
  }

  get unit() {
    return this.lastRead?.unit
  }

  get lowerBound() {
    const lastRead = this.lastRealRead
    if (lastRead) {
      return lastRead.cumulative
    }

    return 0
  }

  get upperBound() {
    const lastRead = this.lastRealRead
    if (lastRead) {
      const usageInRegisterUnit = this.usage / this.kwhConversionFactor
      const daysSinceRead = dayjs().diff(lastRead.date, "day", false)
      const expectedReadingAdvance =
        Math.round((usageInRegisterUnit * daysSinceRead) / DAYS_YEAR) * 4
      return lastRead.cumulative + Math.max(100, expectedReadingAdvance)
    } else {
      return DEFAULT_UPPER_BOUND
    }
  }

  get kwhConversionFactor() {
    return this.lastRead ? this.lastRead.kwhConversionFactor : 1
  }

  get hadSpikeInUsage() {
    const lastRead = this.lastRealRead
    const readingBeforeLast = getLatestRegisterReading(this, {}, true)

    if (lastRead && readingBeforeLast) {
      const usageInRegisterUnit = this.usage / this.kwhConversionFactor
      const daysBetweenReads = lastRead.date.diff(
        readingBeforeLast.date,
        "day",
        false,
      )
      const expectedReadingAdvance =
        Math.round((usageInRegisterUnit * daysBetweenReads) / DAYS_YEAR) * 4

      return (
        readingBeforeLast.cumulative + Math.max(100, expectedReadingAdvance) <
        lastRead?.cumulative
      )
    } else {
      return false
    }
  }
}
